import { render, staticRenderFns } from "./AclGrant.vue?vue&type=template&id=4cea9f77&scoped=true&"
import script from "./AclGrant.vue?vue&type=script&lang=js&"
export * from "./AclGrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea9f77",
  null
  
)

export default component.exports